import styled from 'styled-components/macro';
import Icon from '../../../../../components/UI/Icon/Icon';

const ToolbarIcon = styled(Icon)`
	height: 14px;
	color: #fafafa;
`;

export default ToolbarIcon;
